// @ts-nocheck
import React from 'react';
import _ from 'lodash';
import nl2br from 'react-nl2br';
import NumberFormat from 'react-number-format';
import './styles.scss';
import moment from 'moment';

type State = {
  id: any;
  data: object | null;
  componentRef: React.Ref<any>;
};

const PrintNewSalesOrderReceipts: React.FC<State> = ({ id, data = null, componentRef }) => {
  return (
    <div ref={componentRef}>
      <div className='print-component'>
        <table className='table-header'>
          <tbody>
            <tr>
              <td>Nota Penjualan</td>
            </tr>
            <tr>
              <td>087888221655</td>
            </tr>
          </tbody>
        </table>

        <table>
          <tbody>
            <tr>
              <td>NO. FAKTUR</td>
              <td>:</td>
              <td>{_.get(data, 'number')}</td>
            </tr>
            <tr>
              <td>TANGGAL</td>
              <td>:</td>
              <td>{moment(_.get(data, 'date')).format('D MMMM YYYY HH:mm A')}</td>
            </tr>
            <tr>
              <td>JATUH TEMPO</td>
              <td>:</td>
              <td>{moment(_.get(data, 'dueDate')).format('D MMMM YYYY HH:mm A')}</td>
            </tr>
            <tr>
              <td>KASIR</td>
              <td>:</td>
              <td>{_.get(data, 'creatorName')}</td>
            </tr>
          </tbody>
        </table>

        <hr />

        <table>
          <tbody>
            <tr>
              <td>PELANGGAN</td>
              <td>:</td>
              <td>{_.get(data, 'customer_id.name')}</td>
              <td className='space-left'></td>
              <td></td>
            </tr>
            <tr>
              <td>ALAMAT</td>
              <td>:</td>
              <td>{_.get(data, 'customer_id.address')}</td>
              <td className='space-left'>CHECKING</td>
              <td>:</td>
            </tr>
            <tr>
              <td>TELP</td>
              <td>:</td>
              <td>{_.get(data, 'customer_id.mobile_phone')}</td>
              <td className='space-left'>PACKING</td>
              <td>:</td>
            </tr>
          </tbody>
        </table>

        <hr />

        <table className='table-bordered table-list font-upsize'>
          <thead>
            <tr>
              <th></th>
              <th className='text-start'>NAMA BARANG</th>
              <th>QTY</th>
              <th>@HARGA</th>
              <th className='text-end'>JUMLAH Rp</th>
            </tr>
          </thead>
          <tbody>
            {_.get(data, 'products', []).map((item: any, key: number) => {
              const subtotal = _.get(item, 'price') * 1 * (_.get(item, 'quantity') * 1);

              return (
                <tr key={key}>
                  <td className='no-wrap'>
                    <NumberFormat
                      defaultValue={key + 1}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                      suffix={'.'}
                    />
                  </td>
                  <td className='text-start'>{_.get(item, 'product_id.name')}</td>
                  <td>
                    <NumberFormat
                      defaultValue={_.get(item, 'quantity')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />{' '}
                    {_.get(item, 'unit_id.code')}
                  </td>
                  <td>
                    <NumberFormat
                      defaultValue={_.get(item, 'price')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                  <td className='text-end'>
                    <NumberFormat
                      defaultValue={subtotal}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <hr />

        <div className='row'>
          <p className='print-text-note'>{nl2br(`Keterangan: ${_.get(data, 'note', '-')}`)}</p>
          <p className='print-text-note mb-4'>
            Terima kasih sudah berbelanja. Harap memeriksa kembali pesanan yang diterima.
          </p>
          <div className='col-4' />
          <div className='col-8'>
            <table className='table-summary'>
              <tbody>
                <tr>
                  <td className='text-end'>Subtotal</td>
                  <td className='text-end'>
                    <NumberFormat
                      value={_.get(data, 'summary.subtotal')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='text-end'>Potongan</td>
                  <td className='text-end'>
                    <NumberFormat
                      value={_.get(data, 'summary.discount')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='text-end'>Potongan Tambahan</td>
                  <td className='text-end'>
                    <NumberFormat
                      value={_.get(data, 'discount')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='text-end'>Total</td>
                  <td className='text-end'>
                    <NumberFormat
                      value={_.get(data, 'summary.total')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='text-end'>Bayar</td>
                  <td className='text-end'>
                    <NumberFormat
                      value={_.get(data, 'summary.payment')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
                <tr>
                  <td className='text-end'>Kembali</td>
                  <td className='text-end'>
                    <NumberFormat
                      value={_.get(data, 'summary.balance')}
                      displayType={'text'}
                      thousandSeparator={'.'}
                      decimalSeparator={','}
                      decimalScale={0}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintNewSalesOrderReceipts;
